import React from 'react';
import { Product } from 'types/product';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import { productTableTemplate } from '../../template/productTableTemplate';

type ProductListTableProps = {
  products: Product[];
};

const ProductListTable: React.FC<ProductListTableProps> = ({ products }) => {
  return (
    <DataGridList
      template={productTableTemplate}
      rows={products}
      getRowId={row => row.id}
      onRowClick={row => history.push(`/products/${row.id}`)}
      fileName="produtos"
      sheetName="Produtos"
    />
  );
};

export default ProductListTable;
